"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TimeInput = void 0;
/* eslint-disable @typescript-eslint/comma-dangle */
const react_1 = __importDefault(require("react"));
const react_hook_form_1 = require("react-hook-form");
const time_input_1 = require("../../input/time-input/time-input");
const maybe_unwrap_1 = require("@app/util/apollo/maybe-unwrap");
const moment_1 = __importDefault(require("moment"));
const TimeInput = ({ control, name, disabled, maxHours, disablePicker, label, error, asDateTime }) => {
    const { field } = (0, react_hook_form_1.useController)({ control, name });
    const e = (0, react_hook_form_1.useWatch)({ control, name });
    const dateTime = (0, moment_1.default)(e);
    const asDateTimeValue = dateTime.get('hours') * 60 + dateTime.get('minutes');
    return react_1.default.createElement(time_input_1.TimeInput
    // size="full-width"
    , { 
        // size="full-width"
        label: label, disabled: field.disabled || disabled, value: asDateTime ? asDateTimeValue : e, onChange: (v) => {
            if (asDateTime) {
                const newDateTime = (0, moment_1.default)(e);
                newDateTime.hours(Math.floor(v / 60));
                newDateTime.minutes(v - Math.floor(v / 60) * 60);
                field.onChange(newDateTime);
                return;
            }
            field.onChange(v);
        }, 
        // onBlur={field.onBlur}
        name: field.name, maxHours: maxHours, disablePicker: disablePicker, error: (0, maybe_unwrap_1.unwrapMaybe)(error) });
};
exports.TimeInput = TimeInput;
